// extracted by mini-css-extract-plugin
export default {"container":"GeoBlockedPopup_container__LlDn1","closed":"GeoBlockedPopup_closed__jblCA","icon":"GeoBlockedPopup_icon__D6egH","title":"GeoBlockedPopup_title__6opgh"};